import { render, staticRenderFns } from "./Bikentapedia.vue?vue&type=template&id=b0a7e428&"
import script from "./Bikentapedia.vue?vue&type=script&lang=js&"
export * from "./Bikentapedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports